export const getOnlyDigits = string =>
	string?.replace(/\D/g, "");
